<template>
<div>
	<div class="container container--narrow" id="questionList">
		<div class="subtabs questions-tab-scrollable">
				<div class="mdc-tab-bar main-tabs" role="tablist" ref="questionTab">
					<div class="mdc-tab-scroller">
						<div class="mdc-tab-scroller__scroll-area">
							<div class="mdc-tab-scroller__scroll-content justify-content-center">
                <div v-for="(solve, index) in solves" :key="index">
								<button class="mdc-tab" role="tab" aria-selected="true"
                        :class="solve.questionId === currentQuestionId ? 'mdc-tab--active' : ''"
                        @click="moveQuestion(solve, index)" @keypress="moveQuestion(solve, index)" tabindex="0">
									<span class="mdc-tab__content">
										<span :class="solve.correct ? 'correct' : 'incorrect'"></span>
										<span class="mdc-tab__text-label font-rb t-body1" :class="{'t-color-quizBlueGray previuos--tab': solve.questionId !== currentQuestionId && index < currentQuestionNumber,'t-color-headlineBlack': solve.questionId === currentQuestionId || index >= currentQuestionNumber}">{{ index + 1 }}</span>
									</span>
									<span v-bind:class="['mdc-tab-indicator', { 'mdc-tab-indicator--active' : solve.number === currentQuestionNumber }]">
										<span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
									</span>
									<span class="mdc-tab__ripple"></span>
								</button>
                </div>
							</div>
						</div>
					</div>
				</div>
		</div>
	</div>
	<div class="divider divider-subtabs"></div>
</div>
</template>

<script>
/**
 * 시험 피드백 문항 네비게이션 컴포넌트(exam feedback question navigation component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTabBar, MDCTabBarFoundation} from '@material/tab-bar'
export default {
	props: ['solves', 'currentQuestionId', 'currentQuestionNumber'],
	data() {
		return {
			questionTab: null,

		}
	},

	mounted() {
		this.questionTab = new MDCTabBar(this.$refs.questionTab)
		var tabBar = new mdc.tabBar.MDCTabBar(document.querySelector('.mdc-tab-bar'));

	},

	methods: {
		// 문항 이동(move question)
		moveQuestion(solve, index) {
			this.$emit('selectQuestionNavi', solve, index)
		},

		isCurrentQuestion(questionId) {
			return questionId === this.currentQuestionId
		}
	}

}
</script>
